module.exports = __webpack_public_path__ + "img/sem-foto.f33e833b.png";